import { SelectInput } from './select.mjs';
import { registerCustomElement } from '../utils.mjs';

export class UdtTypeInput extends SelectInput {
	get hasModeSwitch() {
		return false;
	}

	get stateDataProps() {
		return [];
	}

	// This forces `showNestedFieldsets` to pass nested value to `udtspec` instead of all default values (and it solves)
	// a bug with existing data structure collections being copied to new data structure collections
	get checkForNestedValues() {
		return true;
	}

	get allowApiCall() {
		return true;
	}

	/**
	 * Builds the input dom.
	 *
	 * @param {object} instructions Collection of directives.
	 * @param {any} value Initial value.
	 * @param {object} metadata Metadata.
	 */

	async _build(instructions, value, metadata) {
		await super._build(instructions, value, metadata);
	}

	extendInstructions(instructions, value, metadata) {
		const types = [
			{
				label: 'Array',
				value: 'array',
				nested: [
					{
						name: 'spec',
						type: 'collection',
						label: 'Array Item Specification',
						spec: [
							{
								name: 'type',
								label: 'Type',
								type: 'udttype',
								...(instructions.allowedTypes ? { allowedTypes: instructions.allowedTypes } : {}),
								required: true,
								default: 'text',
							},
						],
						mappable: false,
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Collection',
				value: 'collection',
				nested: [
					{
						name: 'spec',
						label: 'Specification',
						type: 'udtspec',
						...(instructions.allowedTypes ? { allowedTypes: instructions.allowedTypes } : {}),
					},
					{
						name: 'sequence',
						label: 'Preserve the order of object keys',
						type: 'boolean',
						mappable: false,
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Date',
				value: 'date',
				nested: [
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Text',
				value: 'text',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'text',
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
					{
						name: 'multiline',
						label: 'Multi-line',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Number',
				value: 'number',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'number',
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Boolean',
				value: 'boolean',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'boolean',
						mappable: false,
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Binary Data',
				value: 'buffer',
				nested: [
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
					{
						name: 'codepage',
						label: 'Codepage',
						type: 'text',
						help: "Possible values: `binary`, `utf8`. Leave empty if you're not sure.",
					},
				],
			},
			{
				label: 'Connection',
				value: 'account',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'account',
						mappable: false,
					},
				],
			},
			{
				label: 'Select',
				value: 'select',
				nested: [
					{
						name: 'options',
						type: 'array',
						label: 'Options',
						labels: {
							add: 'Add option',
						},
						spec: [
							{
								name: 'value',
								label: 'Name',
								type: 'text',
								required: true,
							},
						],
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Dynamic collection',
				value: 'dynamicCollection',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'text',
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Uinteger',
				value: 'uinteger',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'uinteger',
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Integer',
				value: 'integer',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'integer',
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Email',
				value: 'email',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'email',
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'URL',
				value: 'url',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'url',
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'UUID',
				value: 'uuid',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'uuid',
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Color',
				value: 'color',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'color',
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
			{
				label: 'Any',
				value: 'any',
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: 'any',
					},
					{
						name: 'required',
						label: 'Required',
						type: 'boolean',
						required: true,
						default: false,
						mappable: false,
					},
				],
			},
		];

		const defaultAllowedTypes = ['array', 'collection', 'date', 'text', 'number', 'boolean', 'buffer'];
		const allowed = instructions.allowedTypes || defaultAllowedTypes;

		instructions.options = {
			store: types.reduce((acc, type) => {
				if (allowed.includes(type.value)) {
					acc.push(type);
				}

				return acc;
			}, []),
		};

		if (!allowed.includes(value) && instructions?.allowUnknownType) {
			instructions.options.store.push({
				label: value,
				value,
				nested: [
					{
						name: 'default',
						label: 'Default value',
						placeholder: 'Enter default value',
						type: value,
						mappable: false,
					},
				],
			});
			this.classList.add('has-unknown-type');
		}

		return instructions;
	}
}

registerCustomElement('imt-input-udttype', UdtTypeInput);
